import { motion } from "framer-motion";
import { Reveal, Label } from "./Motion";
import { SHOWPIECES } from "../data";

export const Showpieces = ({ scrollTo }) => (
  <section id="showpieces" data-testid="showpieces" className="relative py-24 md:py-36 bg-[#2c2826] text-[#F7F5F0] pc-grain overflow-hidden">
    <div className="relative mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-16">
        <div>
          <Reveal><Label className="text-[#c9a06f]">Showpieces</Label></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
              Sculptural<br /><span className="italic text-[#E8942E]">statements.</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <p className="max-w-sm text-[#c8beb4] leading-relaxed">
            Collectible figurines in gold, ivory and champagne — the finishing touch that
            gives a room its personality.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-12 gap-5 md:gap-6">
        {SHOWPIECES.map((p, i) => (
          <Reveal key={p.id} delay={(i % 3) * 0.08} className={p.span}>
            <motion.button
              data-testid={`showpiece-${p.id}`}
              onClick={() => scrollTo("enquire")}
              whileHover="hover"
              className="group relative block w-full text-left overflow-hidden border border-[#413a33] bg-[#39332d]"
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <motion.img
                  src={p.img} alt={p.name}
                  variants={{ hover: { scale: 1.05 } }}
                  transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                  className="h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2c2826] via-transparent to-transparent" />
                <span className="absolute top-4 left-4 rounded-full bg-[#F7F5F0]/10 backdrop-blur-sm border border-[#F7F5F0]/20 px-3 py-1 text-[11px] uppercase tracking-[0.2em] text-[#e7ddcf]">
                  {p.tag}
                </span>
                <div className="absolute bottom-0 left-0 p-6 md:p-7">
                  <h3 className="font-serif text-2xl md:text-3xl text-[#F7F5F0]">{p.name}</h3>
                  <p className="mt-2 max-w-sm text-[#c8beb4] text-sm leading-relaxed">{p.desc}</p>
                  <span className="mt-4 inline-flex items-center gap-2 text-[#F7F5F0] text-sm border-b border-[#F7F5F0]/40 pb-0.5 group-hover:border-[#E8942E] group-hover:text-[#E8942E] transition-colors duration-300">
                    Enquire &rarr;
                  </span>
                </div>
              </div>
            </motion.button>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
